import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { DoubleArrowLeft, DoubleArrowRight } from '@rsos/assets/icons';
import Box from '@rsos/components/capstone/base/Box';
import { LayoutContext } from '@rsos/components/capstone/base/Layout';
import Text from '@rsos/components/capstone/base/Text';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import ScrollableSideBarItems from '../common/ScrollableSideBarItems';
import { Wrapper, FooterContainer } from '../common/SideBar.styles';
import useRenderSideBarItems from '../common/useRenderSideBarItems';
import SideBarItem from './SideBarItem';
import cspSideBarItems from './cspSideBarItems';
import { whichItemIsActive } from './utils';

const SideBarCSP = () => {
  const location = useLocation();
  const currentPathName = location.pathname;

  const sideBarItems = useRenderSideBarItems(cspSideBarItems);

  const { layout } = useContext(LayoutContext);
  const windowWidth = layout.window.width;

  const [sideBarOpen, setSideBarOpen] = useState(
    window.innerWidth <= BP_LAPTOP ? false : true,
  );

  const sideBarHandler = () => {
    setSideBarOpen(prev => !prev);
  };

  useEffect(() => {
    windowWidth <= BP_LAPTOP ? setSideBarOpen(false) : setSideBarOpen(true);
  }, [windowWidth]);

  return (
    <Wrapper sideBarOpen={sideBarOpen}>
      <ScrollableSideBarItems>
        {sideBarItems.map(menuItem => (
          <SideBarItem
            key={menuItem.id}
            activeItem={whichItemIsActive(currentPathName)}
            menuItem={menuItem}
            sideBarOpen={sideBarOpen}
          />
        ))}
      </ScrollableSideBarItems>
      <FooterContainer onClick={sideBarHandler}>
        {sideBarOpen ? (
          <Box horizontal align="center" flow={7}>
            <DoubleArrowLeft width={12} height={12} />
            <Text noWrap size="normal">
              Collapse
            </Text>
          </Box>
        ) : (
          <DoubleArrowRight width={12} height={12} />
        )}
      </FooterContainer>
    </Wrapper>
  );
};

export default SideBarCSP;
